import { apiService } from '@/utils/api/index';
import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError } from '@/utils/alerts.service';

export const detail = {
  namespaced: true,
  state: {
    matchmakingDetail: {},
    matchmakingStatus: 'N',
    agencyPartners: [],
    integrationPartners: [],
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    matchmakingDetail(state) {
      return state.matchmakingDetail;
    },
    agencyPartners(state) {
      return state.agencyPartners;
    },
    integrationPartners(state) {
      return state.integrationPartners;
    },
    matchmakingStatus(state) {
      return state.matchmakingStatus;
    },
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data;
    },
    setMatchmakingDetail(state, data) {
      state.matchmakingDetail = data;
    },
    setMatchmakingStatus(state, data) {
      state.matchmakingStatus = data;
    },
    setAgencyPartners(state, data) {
      state.agencyPartners = data;
    },
    setIntegrationPartners(state, data) {
      state.integrationPartners = data;
    },
  },
  actions: {
    async fetchMatchmakingDetail({ dispatch, commit }, { id, internal }) {
      return vendorDashboardAPI
        .getMatchmakingDetail(id, internal)
        .then(data => {
          commit('setMatchmakingDetail', data);
          commit('setMatchmakingStatus', data.status);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
    fetchAgencyPartners({ commit }) {
      return new Promise(async resolve => {
        const res = await apiService.get(
          `/dashboard_vendor/matchmaking/dropdown/builder/`
        );
        commit(
          'setAgencyPartners',
          res.map(item => {
            return {
              name: item.agencyName,
              value: item.id,
            };
          })
        );
        resolve(
          res.map(item => {
            return {
              name: item.agencyName,
              value: item.id,
            };
          })
        );
      });
    },
    async fetchIntegrationPartners({ commit }) {
      return new Promise(async resolve => {
        const res = await apiService.get(
          `/dashboard_vendor/matchmaking/dropdown/builder/?integrations=true`
        );
        commit(
          'setIntegrationPartners',
          res.map(item => {
            return {
              name: item.vendorName,
              value: item.id,
            };
          })
        );
        resolve(
          res.map(item => {
            return {
              name: item.vendorName,
              value: item.id,
            };
          })
        );
      });
    },
  },
};
